/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getHead.defs'
export { main as default } from './getHead.defs'
